/**
 * Which backend produced the end-of-page recommendations that were rendered.
 *
 * Emitted as the `recommendationSource` attribute on the `endOfPageRecommendations`
 * observed/rendered track events so an event can be attributed to a single source
 * without inferring it from the per-slot `strategies` array.
 */
export const RECOMMENDATION_SOURCE = {
	CC_SMARTS: 'CC_SMARTS',
	TWG: 'TWG',
} as const;

export type RecommendationSource =
	(typeof RECOMMENDATION_SOURCE)[keyof typeof RECOMMENDATION_SOURCE];
